import React from 'react';

const steps = [
  { num: '1', title: 'Set Up', desc: 'Create your organization, add departments, and define shift types in minutes.' },
  { num: '2', title: 'Add Staff', desc: 'Onboard employees with roles, skills, and availability preferences.' },
  { num: '3', title: 'Schedule', desc: 'Generate smart rosters automatically or customize manually with drag-and-drop.' },
  { num: '4', title: 'Monitor', desc: 'Track attendance, manage leave, and get real-time analytics — all from one dashboard.' },
];

function HowItWorks() {
  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">How It Works</div>
          <h2 className="section-title">Up and Running in 4 Simple Steps</h2>
          <p className="section-subtitle">
            Get your entire workforce management set up in under an hour.
            No complex configurations, no steep learning curve.
          </p>
        </div>
        <div className="steps-grid">
          {steps.map((s, i) => (
            <div className={`step-card fade-in fade-in-delay-${i + 1}`} key={i}>
              <div className="step-number">{s.num}</div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
